#import "../fragments/external-meeting-fragment.graphql"

query GetExternalMeetings(
    $isLogged: Boolean!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $serviceTypes: [ExternalServiceType!]!
) {
    externalMeetings(
        isLogged: $isLogged
        after: $after
        before: $before
        first: $first
        last: $last
        serviceTypes: $serviceTypes
    ) {
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        count
        edges {
            node {
                ...ExternalMeetingFragment
            }
        }
    }
}
